import './index.css';

export default {
  name: 'Anumber',
  props: {
    speed: { type: String | Number, default: () => 3000 }, // 值越小速度越快
    value: { type: String | Number, default: () => null },
    values: { type: String | Number, default: () => null },
    number: { type: String | Number, default: () => null },
    context: { type: String | Number, default: () => null },
    content: { type: String | Number, default: () => null },
  },
  data() {
    return ({
      count: 0,
    });
  },
  watch: {
    value() { this.create() },
    values() { this.create() },
    number() { this.create() },
    context() { this.create() },
    content() { this.create() },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.revoke();
      this.$nextTick(() => {
        let interval = null;
        if (interval) {
          clearInterval(interval);
          interval = null;
        } else {
          const value = this.value || this.values || this.number || this.context || this.content || 0;
          const number = Number(value);
          const ratio = Math.max(parseInt((number * 10) / parseInt(this.speed)), 1);
          interval = setInterval(() => {
            this.count += ratio;
            if (this.count >= number) {
              this.count = number;
              clearInterval(interval);
              interval = null;
            }
          }, 10);
        }
      });
    },
    revoke() {
      this.count = 0;
    },
  },
  render() {
    const { label, unit, padding, margin } = this.$attrs;
    return (
      <span class="a-number" style={{ padding, margin }}>
        {label && (<span class="label">{label}</span>)}
        {this.$slots.default}
        <span class="value">{this.count}</span>
        {unit && (<span class="unit">{unit}</span>)}
      </span>
    );
  },
}